function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3630",
    transform: "translate(-1552 -400)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 29",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1552 400)",
    style: {
      fill: "#ffd949"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 30",
    cx: 5.6,
    cy: 5.6,
    r: 5.6,
    transform: "translate(1554.4 402.4)",
    style: {
      fill: "#e5af18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 150",
    d: "m30 33.738-2.122 1.181c-.293.163-.484.02-.427-.321l.416-2.484-1.728-1.752c-.238-.241-.164-.476.164-.524l2.378-.352 1.056-2.266c.145-.31.379-.311.524 0l1.056 2.266 2.378.352c.328.049.4.282.164.524l-1.728 1.752.416 2.484c.057.34-.134.484-.427.321z",
    transform: "translate(1530.003 376.214)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.1376afa00247f387ff808d3ed6d705a8.svg";
export { ForwardRef as ReactComponent };